jQuery(document).ready(function($){
    $('.faq__frage a[href^="#"]').on('click', function(e) {
        event.preventDefault();

        $('.faq__antwort').hide().removeClass('opentab');

        $('.faq__frage').removeClass('opentab');

        $('.faq__frage a').css("font-weight", "300");
        $(this).css("font-weight", "500");

        var target = $(this).attr('href');
        $('.faq__antwort'+target).toggle().addClass('opentab');

    })
});